import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'

class ReduxSelectInput extends Component {
  static propTypes = {
    // From Redux Form:
    // { input, label, type, meta: { touched, error } }

    // Required
    input: PropTypes.object.isRequired,

    //Optional
    label: PropTypes.string,
    error: PropTypes.string,
    meta: PropTypes.object,
    handleInputRemoval: PropTypes.func,
    optionalClasses: PropTypes.string,
  }

  renderLabel(label) {
    const { disabled } = this.props

    return label
    ? (
        <label className={disabled ? 'disabled' : null}>
          {label}
        </label>
      )
    : ''
  }

  handleRemoveButtonClick = (event) => {
    event.preventDefault()
    this.props.handleInputRemoval()
  }

  renderRemoveButton() {
    const { handleInputRemoval } = this.props
    return handleInputRemoval
    ? (
      <a className="input-delete-button" onClick={(event)=> this.handleRemoveButtonClick(event)}>
        <svg className="icon"><use xlinkHref="#trash-can" /></svg>
      </a>
    ) : null
  }

  render() {
    const {
      input,
      label,
      meta: {
        touched,
        error
      },
      options
    } = this.props

    const {
      handleInputRemoval,
      optionalClasses,
    } = this.props

    return (
      <div
        className={`input-container select-container${optionalClasses ? ' ' + optionalClasses : ''}${touched && error ? ' error' : ''}`}
      >
        {this.renderLabel(label)}
        <div className={`input-container-inner${handleInputRemoval ? ' removable' : ''}`}>
          <div className="Select-container">
            <Select
              {...this.props}
              value={input.value}
              onChange={(value) => input.onChange(value)}
              onBlur={() => input.onBlur(input.value)}
              options={options}
              clearable={false}
            />
          </div>
          {this.renderRemoveButton()}
        </div>
        {touched && error &&
          <div className="input-error-message">
            {error}
          </div>
        }
      </div>
    )
  }
}


export default ReduxSelectInput



// WEBPACK FOOTER //
// ./src/components/Global/ReduxForms/ReduxSelectInput.js